import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, ArrowRight } from 'lucide-react';

const SidebarNotification = () => {
  const [visible, setVisible] = useState(false);
  const [closing, setClosing] = useState(false);

  // Show initially after a short delay and then every 45 seconds, but only Telegram
  useEffect(() => {
    // Check localStorage to see if user permanently closed it
    const isHidden = localStorage.getItem('hideTelegramSidebar') === 'true';
    if (isHidden) return;

    // First appear after 45 seconds
    const initial = setTimeout(() => {
      const stillHidden = localStorage.getItem('hideTelegramSidebar') === 'true';
      if (stillHidden) return;
      setVisible(true);
    }, 45000);

    const interval = setInterval(() => {
      const stillHidden = localStorage.getItem('hideTelegramSidebar') === 'true';
      if (stillHidden) return;
      setVisible(true);
    }, 45000);
    
    return () => {
      clearTimeout(initial);
      clearInterval(interval);
    };
  }, []);

  // Auto-hide a few seconds after becoming visible
  useEffect(() => {
    if (!visible || closing) return;
    const t = setTimeout(() => handleClose(), 6000); // give them bit more time (6s)
    return () => clearTimeout(t);
  }, [visible, closing]);

  const handleClose = () => {
    // Set to localStorage so it doesn't come back in this session or future ones
    localStorage.setItem('hideTelegramSidebar', 'true');
    setClosing(true);
    setTimeout(() => {
      setVisible(false);
      setClosing(false);
    }, 300);
  };

  const handleJoinClick = () => {
    // Hide permanently
    localStorage.setItem('hideTelegramSidebar', 'true');
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.aside
          className="fixed right-4 bottom-6 z-50"
          initial={{ x: '100%' }}
          animate={{ x: 0 }}
          exit={{ x: '100%' }}
          transition={{ type: 'spring', stiffness: 300, damping: 30 }}
        >
          <div className={`w-72 rounded-l-xl shadow-xl overflow-hidden bg-gradient-to-br from-indigo-600 to-purple-600 text-white`}>
            <div className="p-4 relative">
              <button
                aria-label="Close notification"
                onClick={handleClose}
                className="absolute right-2 top-2 text-white/80 hover:text-white"
              >
                <X size={16} />
              </button>
              <h3 className="text-lg font-semibold">Daily Free Trial Call</h3>
              <p className="text-sm text-indigo-100 mt-1">
                Join our Telegram for daily free trial calls and market research updates.
              </p>
              <a
                href="https://t.me/omkarresearchanalyst123"
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleJoinClick}
                className="mt-4 inline-flex items-center justify-between w-full bg-white text-indigo-700 px-4 py-2 rounded-md font-medium text-sm hover:bg-gray-100 transition-colors"
              >
                Join Telegram
                <ArrowRight size={16} className="ml-2" />
              </a>
            </div>
          </div>
        </motion.aside>
      )}
    </AnimatePresence>
  );
};

export default SidebarNotification;
